var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 14H19V12C19 8.3125 16.125 5.3125 12.5 5.03125V4H13.75C13.875 4 14 3.90625 14 3.75V3.25C14 3.125 13.875 3 13.75 3H10.25C10.0938 3 10 3.125 10 3.25V3.75C10 3.90625 10.0938 4 10.25 4H11.5V5.03125C7.84375 5.3125 5 8.3125 5 12V14H4.25C4.09375 14 4 14.125 4 14.25V14.75C4 14.9062 4.09375 15 4.25 15H19.75C19.875 15 20 14.9062 20 14.75V14.25C20 14.125 19.875 14 19.75 14ZM18 14H6V12C6 8.875 8.4375 6.25 11.5625 6.03125C12.0938 6 11.875 6 12.4062 6.03125C15.5312 6.25 18 8.875 18 12V14Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/room.2d663fbe.svg";
export { ForwardRef as ReactComponent };